import React from "react";

const Close = () => {
  return (
    <svg
      className="close"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 26.71 26.71"
    >
      <title>Close</title>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <line className="cls-1" x1="1.41" y1="25.29" x2="25.29" y2="1.41" />
          <line className="cls-1" x1="25.29" y1="25.29" x2="1.41" y2="1.41" />
        </g>
      </g>
    </svg>
  );
};

export default Close;
